module.exports = {"menu":{"drawingSystem":"Drawing System","drawingSystem2":"Drawing System New","about":"About","master":"Master Data","sellOrder":"Request Drawing","user":"Users","settings":"Settings","systemSettings":"System"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/menu.json
// module id = 540
// module chunks = 14